export default __webpack_public_path__ + "static/media/reorder-icon.84582b1d.png";